import React, { PropsWithChildren, useMemo, useState, ReactElement, ReactNode } from 'react';
import { NotificationCounterContext } from 'models/notificationCounterContext';

type ProviderProps = PropsWithChildren<{ children: ReactNode }>;
export const NotificationCounterProvider = ({ children }: ProviderProps): ReactElement => {
  const [counter, setCounter] = useState<number>(0);

  const value = useMemo(() => ({ counter, setCounter }), [counter, setCounter]);

  return (
    <NotificationCounterContext.Provider value={value}>
      {children}
    </NotificationCounterContext.Provider>
  );
};
